module.exports = __webpack_public_path__ + "static/MJS_Electronics_BEE_Cert_2020-10601d2576ff4b745cba1eb1cfd5799b.pdf";